export default "__VITE_ASSET__dJ$ULFcuzX43djbIEsCZPw__"